import Sha256 from 'helpers/sha256'
import {getCookieUsername} from 'helpers/browser'
import {trackPageView} from 'helpers/tracking'
import {excludedPathsFromLocationMemory, normalizePathname} from "helpers/navigation"

export const onLocationChanged = (location) => {
  const {pathname} = location

  if (!excludedPathsFromLocationMemory.includes(normalizePathname(String(pathname).toLowerCase()))) {
    window.localStorage.setItem(getModuleLocationKey(getCookieUsername(), pathname), pathname)
    window.localStorage.setItem(getLocationKey(getCookieUsername()), pathname)
  }
  trackPageView(location)
}

export const getLocationKey = (user) => `location-${Sha256.hash(user)}`

export const getLastLocation = (user) => {
  user = user || getCookieUsername()
  if (user == null) return ''
  return localStorage.getItem(getLocationKey(user)) || ''
}

export const getModuleLocationKey = (user, moduleUrl) => {
  const url = moduleUrl.split('/')[1]
  return `location-${Sha256.hash(`${user}-${url}`)}`
}
